module.exports = __webpack_public_path__ + "static/bg-d015711fb65d1738de86f8bbe8af63c3.jpg";